<!--日期按钮-->
<template>
	<div class='dateButtonBody' @click="dateClick" style='fontStyle'>
		{{name}}<span>{{date}}<img :src="getResourcesByName('wedoButton/date.png')"></span>
	</div>
</template>

<script type="text/javascript">
	//日期:date
	//名字:name
	export default {
	        name: 'dataButton',
	        components: {},
	        props: {date:{},name:{},fontStyle:{
						type:Object,default:()=>{
							return {
								'color':'white'
							}
						}
					}},
	        data() {
	           return {}
	        },
	        created() {},
	        mounted() {},
	        destroyed() {},
	        computed: {
	        	getResourcesByName(){
					return this.$store.resourcesStore.getters.getResourcesByName
				},
	        },
	        watch: {},
	        methods: {
	        	dateClick(){
	        	  this.$emit('dateClick')	
	        	}
	        }
	    }
</script>

<style scoped>
	.dateButtonBody{
		font-size: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor:pointer;
		margin-left: 5px;
		
	}
	.dateButtonBody span{
		padding-left: 5px;
		margin:0 5px;
		display: flex;
		height: 0.28rem;
    	align-items: center;
		border: .01rem solid #d4d4d4;
		border-radius: .04rem;
		font-size: .12rem;
	}
	.dateButtonBody img{
		margin: 0 5px;
		width: 15px;
		height: 15px;
	}
</style>